import callDotNet from "../blazor/callDotNet";

const keybinds = [];

// Helper function to determine if the active element is a form or editable element
const isFormElement = (element) => {
  return (element && (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.hasAttribute('contenteditable') || element.tagName === 'SELECT'));
};

document.addEventListener('keydown', (e) => {
  // Skip keybind detection if the focus is inside a form, editable, or input element
  if (isFormElement(document.activeElement)) {
    return;
  }

  let value = '';
  if (e.ctrlKey) {
    value += "Ctrl+";
  }

  if (e.shiftKey) {
    value += "Shift+";
  }

  if (e.altKey) {
    value += "Alt+";
  }

  if (e.key.length === 1) {
    value += e.key.toUpperCase();
  } else {
    value += e.key;
  }

  for (var i = 0; i < keybinds.length; i++) {
    if (keybinds[i].keybind === value) {
      console.log(`Keybind detected: ${value}`);

      callDotNet(keybinds[i].element, "OnKeybind");
    }
  }
});

export const listen = (element, keybind) => {
  keybinds.push({
    element, keybind,
  });
};

export const unlisten = (element) => {
  const index = keybinds.findIndex(keybind => keybind.element === element);
  if (index >= 0) {
    keybinds.splice(index, 1);
  }
};

export default {
  listen, unlisten,
};
